import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../store';
import { isMobile } from 'react-device-detect';
import { toast } from 'react-toastify';

interface Props {
  children: JSX.Element;
}

export const PrivateRoute: React.FC<Props> = ({ children }) => {
  const token = useSelector((state: RootState) => state.auth ? state.auth.token : null);
  if (!isMobile) {
    return <Navigate to="/" replace state={{ warning: "لطفا با تلفن همراه وارد شوید." }} />
  }

  return token ? children : <Navigate to="/login" replace />;
};
